<div
  [ngClass]="[
    'card d-block sticky-asset-img overflow-hidden',
    shopping_cart && shopping_cart.order_for_person ? 'sticky-asset-img--top' : ''
  ]"
>
  <div class="card-body bg-white">
    <img
      class="img-fluid device-img"
      [src]="device.image_url"
      [alt]="device.name"
      (error)="getPlaceholder(product_category, $event)"
    />
  </div>
</div>
